import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import { Capacitor } from '@capacitor/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { StatusBar, Style } from '@capacitor/status-bar';
import { NavigationBar, NavigationBarColor } from '@capgo/capacitor-navigation-bar';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import App from 'src/App';
import { oneSignalInit } from 'src/onesignal-init';
import reportWebVitals from 'src/reportWebVitals';

if (Capacitor.isNativePlatform()) {
  // Lock screen orientation to portrait mode
  if (Capacitor.isPluginAvailable('ScreenOrientation')) {
    void ScreenOrientation.lock({ orientation: 'portrait' });
  }

  // Notify CapacitorUpdater that the app is ready to check for updates
  void CapacitorUpdater.notifyAppReady();

  // This is needed to display content under a transparent status bar (Android only)
  // ref: https://capacitorjs.com/docs/apis/status-bar#example
  if (Capacitor.getPlatform() === 'android') {
    if (Capacitor.isPluginAvailable('StatusBar')) {
      void StatusBar.setOverlaysWebView({ overlay: true });
      void StatusBar.setStyle({ style: Style.Dark });
    }

    if (Capacitor.isPluginAvailable('NavigationBar')) {
      void NavigationBar.setNavigationBarColor({
        color: NavigationBarColor.TRANSPARENT,
        darkButtons: true,
      });
    }
  }

  oneSignalInit();
}

// Initialize Google Analytics only in production
if (import.meta.env.VITE_DEPLOYMENT_ENVIRONMENT === 'production') {
  ReactGA.initialize('G-D87XE4ST6S');
}

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>, // TODO: re-enable
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example, reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
